import React from 'react'
import "../styles/services.css";
import Navbar from '../components/common/Navbar'
import ServicesHero from '../components/services/ServicesHero'

const ServicesPage = () => {
  return (
    <div>
      <Navbar />
      <ServicesHero />
    </div>
  )
}

export default ServicesPage